import React, { useState, useRef } from "react";
import { useInView } from "../../../hooks/useInView";

export const CollapseComponent = ({ answer, question, delay = 0 }) => {
  const [isActive, setIsActive] = useState(false);
  const contentRef = useRef(null);
  const [revealRef, inView] = useInView();

  return (
    <div
      ref={revealRef}
      className="w-full p-8 collapse-container shadow-lg my-4"
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? "translateY(0)" : "translateY(24px)",
        transition: `opacity 0.5s ease ${delay}ms, transform 0.5s cubic-bezier(0.22, 1, 0.36, 1) ${delay}ms`,
      }}
    >
      <div
        className="flex justify-between w-full cursor-pointer"
        onClick={() => setIsActive((prev) => !prev)}
      >
        <h2 className={`collapse-title ${isActive ? "actived" : ""}`}>
          {question}
        </h2>
        <img
          className={`collapse-toggle ${isActive ? "actived" : ""}`}
          src={isActive ? "./minus-icon.svg" : "./plus-icon.svg"}
          alt="toggle icon"
        />
      </div>

      <div
        ref={contentRef}
        style={{
          maxHeight: isActive ? contentRef.current?.scrollHeight + "px" : "0px",
          overflow: "hidden",
          transition: "max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      >
        <p className="collapse-content actived">{answer}</p>
      </div>
    </div>
  );
};
